import { ReactTFC } from "../../utils/fp/missing-ts-parts";
import { SettingsAnnouncementBarType } from "@swo/storefront";
import { css } from "@emotion/react";
import React from "react";
import {
  SwarovskiLink,
  SwarovskiLinkLinkTypeProps,
  SwarovskiLinkProps,
} from "../_shared-components/ui-elements/SwarovskiLink";
import { Link as SharedLink } from "@swo/shared";

export const AnnouncementContent: ReactTFC<{ announcement: SettingsAnnouncementBarType }> = props => {
  const { text, link } = props.announcement;

  return (
    <p className={"text-aa u-m-0"}>
      {text} {link && <SwarovskiLink {...getSharedLinkProps(link)}>{link.label}</SwarovskiLink>}
    </p>
  );
};

function getSharedLinkProps(link: SharedLink): SwarovskiLinkLinkTypeProps & Pick<SwarovskiLinkProps, "link"> {
  return link.type === "Internal Link"
    ? {
        isInternal: true,
        scrollToTop: true,
        expectSimilarLayout: false,
        link: link.data,
      }
    : {
        isInternal: false,
        openInNewTab: !!link.openInNewTab,
        link: link.data,
      };
}
